import { Button, Typography, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useAuth0 } from "@auth0/auth0-react";

function LoginPage() {
  const { loginWithRedirect: login } = useAuth0();
  const theme = useTheme();

  const loginWithOcctoo = () => {
    window.location.href = "";
  };

  return (
    <Box
      sx={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        bgcolor: "#F5F5F5",
        overflow: "hidden",
      }}
    >
      {/* Circle on the left */}
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: 0,
          transform: "translate(-25%, -50%)",
          width: "calc(2 * max(50vw, 50vh))",
          height: "calc(2 * max(50vw, 50vh))",
          borderRadius: "50%",
          backgroundColor: theme.palette.primary.main,
        }}
      />

      {/* Top-left logo*/}
      <Box sx={{ position: "absolute", top: "2rem", left: "3rem" }}>
        <Box
          component="img"
          src={theme.custom.alligoLogo}
          alt="Top Left Logo"
          sx={{ width: 200 }}
        />
      </Box>

      {/* Bottom-left "Powered by" */}
      <Box
        sx={{
          position: "absolute",
          bottom: "2rem",
          left: "3rem",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Typography variant="body2" sx={{ color: "#fff" }}>
          Powered by
        </Typography>
        <Box
          component="img"
          src={theme.custom.avensiaLogo}
          alt="Powered By Logo"
          sx={{ width: 120 }}
        />
      </Box>

      {/* Main login content */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Box
          display="flex"
          flexDirection="row"
          alignItems="flex-start"
          gap={2}
          sx={{ maxWidth: 800, p: 2 }}
        >
          <Box
            component="img"
            src={theme.custom.avensiaGuyLogo}
            alt="Avensia Guy"
            sx={{ width: 150 }}
          />

          {/* Speech bubble */}
          <Box
            sx={{
              position: "relative",
              backgroundColor: theme.bubbleColor,
              borderRadius: 2,
              padding: 3,
              color: "#fff",
              maxWidth: 400,
              width: "100%",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 20,
                left: -15,
                width: 0,
                height: 0,
                borderStyle: "solid",
                borderWidth: "10px 15px 10px 0",
                borderColor: `transparent ${theme.bubbleColor} transparent transparent`,
              },
            }}
          >
            <Typography variant="h4" fontWeight="bold" mb={1}>
              Hi, welcome to the Lobby!
            </Typography>
            <Typography variant="h6" mb={3}>
              Please log in to continue.
            </Typography>

            <Box display="flex" flexDirection="column" gap={2} width="100%">
              {theme.occtooEnable && (
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  onClick={login}
                  sx={{
                    borderRadius: 3,
                    backgroundColor: theme.palette.primary.light,
                    color: theme.palette.primary.contrastText || "#fff",
                    textTransform: "none",
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    "&:hover": {
                      backgroundColor: theme.palette.primary.main,
                    },
                  }}
                >
                  Log in with Auth0
                </Button>
              )}

              {theme.auth0Enable && (
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  onClick={loginWithAuth0}
                  sx={{
                    borderRadius: 3,
                    backgroundColor: theme.palette.secondary.main,
                    color: theme.palette.secondary.contrastText || "#fff",
                    textTransform: "none",
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    "&:hover": {
                      backgroundColor: theme.palette.secondary.light,
                    },
                  }}
                >
                  Log in with Auth0
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default LoginPage;
